/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventcreatedwithimages3Inputs */

const en_eventcreatedwithimages3 = /** @type {(inputs: Eventcreatedwithimages3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event created with images!`)
};

const de_eventcreatedwithimages3 = /** @type {(inputs: Eventcreatedwithimages3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event mit Bildern erstellt!`)
};

/**
* | output |
* | --- |
* | "Event created with images!" |
*
* @param {Eventcreatedwithimages3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventcreatedwithimages3 = /** @type {((inputs?: Eventcreatedwithimages3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventcreatedwithimages3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventcreatedwithimages3(inputs)
	return de_eventcreatedwithimages3(inputs)
});
export { eventcreatedwithimages3 as "eventCreatedWithImages" }